import axios from 'axios'
import { Dialog, Toast } from 'vant';
import { getLoginStatus } from '@/utils/app';
// create an axios instance
const service = axios.create({
    baseURL: '/api/newlive', // api 的 base_url
    // baseURL: process.env.NODE_ENV === 'production' ? window.g.baseUrl + '/api/newlive' : '/api/newlive',
    timeout: 5000 // request timeout
})

// request interceptor
service.interceptors.request.use(
    config => {
        if (!config.headers['X-Xshop-Token']) {
            config.headers['X-Xshop-Token'] = `${window.localStorage.getItem(
        'Authorization'
      ) || ''}`;
        }
        return config;
    },
    err => Promise.reject(err)
)

// 响应拦截器配置
service.interceptors.response.use(
  (response) => {
    if (response.data.status === 401 || response.data.status === 402) {
      // 删除token

      removeToken();
      localStorage.removeItem("user");
      localStorage.removeItem("routes");
      localStorage.removeItem("roles");
      store.commit("setRoutes", []);
      // 跳转至登录
      if (response.data.status === 401) {
        router.replace("/login?type=overdue");
      } else {
        router.replace("/login?type=repeat");
      }

      return;
    }

    if (response.data.status !== 0) {
      Toast.fail(response.data.desc);
    }

    return response;
  },
  (error) => {
    console.log(error);

    if (error.response.status === 500) {
      Toast.fail(error.response.data.desc);
    } else if (error.response.status === 504) {
      Toast.fail("请求超时，请稍后重试"); // 超时时间设定？
    } else {
      Toast.fail("服务异常，请联系管理员");
    }

    Promise.reject(error);
  }
);

export default service